module.exports = __webpack_public_path__ + "static/media/web-blog.1bb08a57.png";